function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "message-dots-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.75 10H6.75833M10.5 10H10.5083M14.25 10H14.2583M10.5 17.5C14.6421 17.5 18 14.1421 18 10C18 5.85786 14.6421 2.5 10.5 2.5C6.35786 2.5 3 5.85786 3 10C3 10.9976 3.19478 11.9497 3.54839 12.8204C3.61606 12.9871 3.6499 13.0704 3.665 13.1377C3.67976 13.2036 3.68516 13.2524 3.68517 13.3199C3.68518 13.3889 3.67265 13.4641 3.64759 13.6145L3.15344 16.5794C3.10169 16.8898 3.07582 17.0451 3.12397 17.1573C3.16611 17.2556 3.2444 17.3339 3.34265 17.376C3.45491 17.4242 3.61015 17.3983 3.92063 17.3466L6.88554 16.8524C7.03591 16.8273 7.11109 16.8148 7.18011 16.8148C7.24763 16.8148 7.29638 16.8202 7.36227 16.835C7.42962 16.8501 7.51294 16.8839 7.67958 16.9516C8.55025 17.3052 9.50238 17.5 10.5 17.5ZM7.16667 10C7.16667 10.2301 6.98012 10.4167 6.75 10.4167C6.51988 10.4167 6.33333 10.2301 6.33333 10C6.33333 9.76988 6.51988 9.58333 6.75 9.58333C6.98012 9.58333 7.16667 9.76988 7.16667 10ZM10.9167 10C10.9167 10.2301 10.7301 10.4167 10.5 10.4167C10.2699 10.4167 10.0833 10.2301 10.0833 10C10.0833 9.76988 10.2699 9.58333 10.5 9.58333C10.7301 9.58333 10.9167 9.76988 10.9167 10ZM14.6667 10C14.6667 10.2301 14.4801 10.4167 14.25 10.4167C14.0199 10.4167 13.8333 10.2301 13.8333 10C13.8333 9.76988 14.0199 9.58333 14.25 9.58333C14.4801 9.58333 14.6667 9.76988 14.6667 10Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message_circle.b4966f1cab326c96ea7594c5e9422864.svg";
export { ForwardRef as ReactComponent };